module.exports = __webpack_public_path__ + "img/border_Corner_Right.34c2d07a.svg";